"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPDATE_PASSWORD_SUCCESS = exports.LOGOUT_SUCCESS = exports.LOGIN_SUCCESS = undefined;

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.load = load;
exports.login = login;
exports.registerAndLogin = registerAndLogin;
exports.refreshLogin = refreshLogin;
exports.logout = logout;
exports.updatePassword = updatePassword;
exports.resetUpdatePassword = resetUpdatePassword;
exports.forgotPassword = forgotPassword;
exports.checkIfExists = checkIfExists;
exports.loginWithSSOZendesk = loginWithSSOZendesk;
exports.updateScreenNameSSOZendesk = updateScreenNameSSOZendesk;
exports.uploadAvatarZendesk = uploadAvatarZendesk;
exports.setZendeskScreenName = setZendeskScreenName;
exports.setZendeskAvatar = setZendeskAvatar;
exports.epicLogin = epicLogin;
exports.epicLinkAccounts = epicLinkAccounts;
exports.verifyLogin = verifyLogin;
exports.validateEula = validateEula;
exports.acceptEULA = acceptEULA;
exports.resetEULA = resetEULA;
exports.loginError = loginError;
exports.resetLoginError = resetLoginError;

var _jsBase = require("js-base64");

var _jsonwebtoken = require("jsonwebtoken");

var _jsonwebtoken2 = _interopRequireDefault(_jsonwebtoken);

var _jsCookie = require("js-cookie");

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _bluebird = require("bluebird");

var _bluebird2 = _interopRequireDefault(_bluebird);

var _reactRouter = require("react-router");

var _user = require("./user");

var userActions = _interopRequireWildcard(_user);

var _querystring = require("querystring");

var _querystring2 = _interopRequireDefault(_querystring);

var _assets = require("./assets");

var _payments = require("./payments");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = "ms/auth/load";
var LOAD_SUCCESS = "ms/auth/load_success";
var LOAD_FAIL = "ms/auth/load_fail";

var LOGIN = "ms/auth/login";
var LOGIN_SUCCESS = exports.LOGIN_SUCCESS = "ms/auth/login_success";
var LOGIN_FAIL = "ms/auth/login_fail";
var RESET_LOGIN_ERROR = "ms/auth/reset_login_error";

var LOGIN_ZENDESK_SS0 = "ms/auth/login_zendesk_sso";
var LOGIN_SUCCESS_ZENDESK_SS0 = "ms/auth/login_success_zendesk_sso";
var LOGIN_FAIL_ZENDESK_SS0 = "ms/auth/login_fail_zendesk_sso";
var SET_SCREEN_NAME_ZENDESK_SS0 = "ms/auth/set_screen_name";

var UPLOAD_ZENDESK_AVATAR = "ms/auth/zendesk_avatar";
var UPLOAD_SUCCESS_ZENDESK_AVATAR = "ms/auth/success_zendesk_avatar";
var UPLOAD_FAIL_ZENDESK_AVATAR = "ms/auth/fail_zendesk_avatar";
var SET_UPLOAD_ZENDESK_AVATAR = "ms/auth/set_avatar";

var REGISTER = "ms/auth/register";
var REGISTER_SUCCESS = "ms/auth/register_success";
var REGISTER_FAIL = "ms/auth/register_fail";

var REFRESH = "ms/auth/refresh";
var REFRESH_SUCCESS = "ms/auth/refresh_success";
var REFRESH_FAIL = "ms/auth/refresh_fail";

var LOGOUT = "ms/auth/logout";
var LOGOUT_SUCCESS = exports.LOGOUT_SUCCESS = "ms/auth/logout_success";
var LOGOUT_FAIL = "ms/auth/logout_fail";

var UPDATE_INIT = "ms/auth/update_init";
var UPDATE_PASSWORD = "ms/auth/update_password";
var UPDATE_PASSWORD_SUCCESS = exports.UPDATE_PASSWORD_SUCCESS = "ms/auth/update_password_success";
var UPDATE_PASSWORD_FAIL = "ms/auth/update_password_fail";

var FORGOT_PASSWORD = "ms/auth/forgot_password";
var FORGOT_PASSWORD_SUCCESS = "ms/auth/forgot_password_success";
var FORGOT_PASSWORD_FAIL = "ms/auth/forgot_password_fail";

var CHECK_IF_EXISTS = "ms/auth/check_if_exists";
var CHECK_IF_EXISTS_SUCCESS = "ms/auth/check_if_exists_success";
var CHECK_IF_EXISTS_FAIL = "ms/auth/check_if_exists_fail";

var EPIC_LOGIN = "EPIC_LOGIN";
var EPIC_LOGIN_SUCCESS = "EPIC_LOGIN_SUCCESS";
var EPIC_LOGIN_FAIL = "EPIC_LOGIN_FAIL";

var EPIC_LINK_ACCOUNT = "EPIC_LINK_ACCOUNT";
var EPIC_LINK_ACCOUNT_SUCCESS = "EPIC_LINK_ACCOUNT_SUCCESS";
var EPIC_LINK_ACCOUNT_FAIL = "EPIC_LINK_ACCOUNT_FAIL";

var VERIFY_LOGIN = "VERIFY_LOGIN";
var VERIFY_LOGIN_SUCCESS = "VERIFY_LOGIN_SUCCESS";
var VERIFY_LOGIN_FAIL = "VERIFY_LOGIN_FAIL";

var VALIDATE_EULA = "VALIDATE_EULA";
var VALIDATE_EULA_SUCCESS = "VALIDATE_EULA_SUCCESS";
var VALIDATE_EULA_FAIL = "VALIDATE_EULA_FAIL";

var ACCEPT_EULA = "ACCEPT_EULA";
var ACCEPT_EULA_SUCCESS = "ACCEPT_EULA_SUCCESS";
var ACCEPT_EULA_FAIL = "ACCEPT_EULA_FAIL";
var RESET_EULA = "RESET_EULA";

var initialState = {
  loggedIn: false,
  token: null,
  sendingEmail: false,
  emailSent: false,
  zendeskTokenSSO: null,
  screenName: null,
  avatarSrc: null,
  fileUploaded: false,
  screenNameError: null,
  avatarfileName: null,
  epicLogin: {},
  eula: { updateVersion: false, loaded: false, loading: false }
};

// Reducer

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loggedIn: true,
        token: action.result.token,
        refreshToken: action.result.refreshToken,
        user: JSON.parse(_jsBase.Base64.decode(action.result.token.split(".")[1]))
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loggedIn: false,
        user: null,
        token: null,
        refreshToken: null,
        error: action.error
      });
    case LOGIN:
      return (0, _extends3.default)({}, state, {
        user: null,
        token: null,
        refreshToken: null,
        loggingIn: true,
        loginError: null
      });
    case LOGIN_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loggingIn: false,
        loggedIn: true,
        token: action.result.token,
        refreshToken: action.result.refreshToken,
        user: JSON.parse(_jsBase.Base64.decode(action.result.token.split(".")[1]))
      });

    case LOGIN_FAIL:
      return (0, _extends3.default)({}, state, {
        loggingIn: false,
        loggedIn: false,
        user: null,
        token: null,
        refreshToken: null,
        loginError: action.error
      }, action.error.code == "AccountPasswordNotSet" ? {
        checkingIfExists: false,
        checkedIfExistsFor: "login",
        checkedIfExists: action.meta.email,
        checkedIfExistStatus: action.error
      } : {});

    case RESET_LOGIN_ERROR:
      return (0, _extends3.default)({}, state, {
        loginError: null
      });

    case SET_SCREEN_NAME_ZENDESK_SS0:
      return (0, _extends3.default)({}, state, {
        screenName: action.meta.screenName
      });
    case LOGIN_ZENDESK_SS0:
      return (0, _extends3.default)({}, state, {
        loggingIn: true,
        loginError: null
      });
    case LOGIN_SUCCESS_ZENDESK_SS0:
      return (0, _extends3.default)({}, state, {
        loggingIn: false,
        loggedIn: true,
        screenNameError: null,
        zendeskTokenSSO: action.result.token,
        screenName: action.result.screenName
      });

    case LOGIN_FAIL_ZENDESK_SS0:
      return (0, _extends3.default)({}, state, {
        loggingIn: false,
        loggedIn: false,
        screenNameError: action.error
      });

    case SET_UPLOAD_ZENDESK_AVATAR:
      return (0, _extends3.default)({}, state, {
        avatarSrc: action.meta.imgSrc
      });
    case UPLOAD_ZENDESK_AVATAR:
      return (0, _extends3.default)({}, state, {
        fileUploading: true,
        fileUploaded: null,
        loginError: null
      });
    case UPLOAD_SUCCESS_ZENDESK_AVATAR:
      return (0, _extends3.default)({}, state, {
        fileUploading: false,
        fileUploaded: true,
        avatarfileName: action.result.fileName,
        loginError: null
      });
    case UPLOAD_FAIL_ZENDESK_AVATAR:
      return (0, _extends3.default)({}, state, {
        fileUploading: false,
        fileUploaded: false,
        loginError: action.error
      });

    case REFRESH:
      return (0, _extends3.default)({}, state, {
        user: null,
        token: null,
        refreshToken: null,
        refreshing: true,
        refreshError: null
      });
    case REFRESH_SUCCESS:
      return (0, _extends3.default)({}, state, {
        refreshing: false,
        loggedIn: true,
        token: action.result.token,
        refreshToken: action.result.refreshToken,
        user: JSON.parse(_jsBase.Base64.decode(action.result.token.split(".")[1]))
      });
    case REFRESH_FAIL:
      return (0, _extends3.default)({}, state, {
        refreshing: false,
        loggedIn: false,
        user: null,
        token: null,
        refreshToken: null,
        refreshError: action.error
      });
    case LOGOUT:
      return (0, _extends3.default)({}, state, {
        loggingOut: true
      });
    case LOGOUT_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loggingOut: false,
        loggedIn: false,
        user: null,
        token: null,
        refreshToken: null
      });
    case LOGOUT_FAIL:
      return (0, _extends3.default)({}, state, {
        loggingOut: false,
        logoutError: action.error
      });

    case UPDATE_INIT:
      return (0, _extends3.default)({}, state, {
        updatingPassword: false,
        passwordUpdated: false,
        passwordError: null
      });

    case UPDATE_PASSWORD:
      return (0, _extends3.default)({}, state, {
        updatingPassword: true,
        passwordUpdated: false,
        passwordError: null
      });

    case UPDATE_PASSWORD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        updatingPassword: false,
        passwordUpdated: true,
        passwordError: null
      });

    case UPDATE_PASSWORD_FAIL:
      return (0, _extends3.default)({}, state, {
        updatingPassword: false,
        passwordUpdated: false,
        passwordError: true
      });

    case FORGOT_PASSWORD:
      return (0, _extends3.default)({}, state, {
        sendingEmail: true,
        emailSent: false
      });

    case FORGOT_PASSWORD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        sendingEmail: false,
        emailSent: true
      });

    case FORGOT_PASSWORD_FAIL:
      return (0, _extends3.default)({}, state, {
        sendingEmail: false,
        emailSent: false
      });

    case CHECK_IF_EXISTS:
      return (0, _extends3.default)({}, state, {
        checkingIfExistsFor: action.meta.for,
        checkingIfExists: action.meta.email,
        checkedIfExists: false,
        checkedIfExistStatus: null
      });

    case CHECK_IF_EXISTS_SUCCESS:
      if (action.meta.email != state.checkingIfExists) return state;

      return (0, _extends3.default)({}, state, {
        checkingIfExists: false,
        checkingIfExistsFor: false,
        checkedIfExistsFor: action.meta.checkFor,
        checkedIfExists: action.meta.email,
        checkedIfExistStatus: action.result
      });

    case CHECK_IF_EXISTS_FAIL:
      return (0, _extends3.default)({}, state, {
        checkingIfExists: false
      });

    case EPIC_LOGIN:
      return (0, _extends3.default)({}, state, {
        epicLogin: (0, _extends3.default)({}, state.epicLogin, {
          loggingIn: true
        })
      });

    case EPIC_LOGIN_SUCCESS:
      return (0, _extends3.default)({}, state, {
        epicLogin: (0, _extends3.default)({}, state.epicLogin, {
          email: action.result.email,
          epicToken: action.result.epicToken,
          isUnlinkedAccount: action.result.isUnlinkedAccount,
          loggingIn: false
        })
      });

    case EPIC_LOGIN_FAIL:
      return (0, _extends3.default)({}, state, {
        epicLogin: (0, _extends3.default)({}, state.epicLogin, {
          loggingIn: false
        })
      });

    case VALIDATE_EULA:
      return (0, _extends3.default)({}, state, {
        eula: {
          loading: true,
          loaded: false
        }
      });
    case VALIDATE_EULA_SUCCESS:
      var versionUpdate = action.result.hasOwnProperty("version");
      return (0, _extends3.default)({}, state, {
        eula: {
          loading: false,
          loaded: true,
          updateVersion: !!versionUpdate,
          version: action.result.hasOwnProperty("version") && action.result.version
        }
      });
    case VALIDATE_EULA_FAIL:
      return (0, _extends3.default)({}, state, {
        eula: (0, _extends3.default)({
          loading: false,
          loaded: false
        }, action.error)
      });
    case ACCEPT_EULA:
      return (0, _extends3.default)({}, state, {
        eula: (0, _extends3.default)({}, state.eula, {
          loading: true,
          loaded: false
        })
      });
    case ACCEPT_EULA_SUCCESS:
      return (0, _extends3.default)({}, state, {
        eula: (0, _extends3.default)({}, state.eula, {
          loading: false,
          loaded: false,
          eulaAccepted: (0, _extends3.default)({}, action.result)
        })
      });
    case ACCEPT_EULA_FAIL:
      return (0, _extends3.default)({}, state, {
        eula: (0, _extends3.default)({}, state.eula, {
          loading: false,
          loaded: false,
          eulaAccepted: (0, _extends3.default)({}, action.error)
        })
      });
    case RESET_EULA:
      return (0, _extends3.default)({}, state, {
        eula: {
          loading: false,
          loaded: false,
          eulaAccepted: null,
          updateVersion: false
        }
      });

    default:
      return state;
  }
}

// Action creators

function load() {
  return function (dispatch, getState) {
    var savedState = void 0;
    if (__SERVER__) {
      var _getState = getState(),
          req = _getState.server.req;

      savedState = req && req.cookies && req.cookies.auth;
    } else if (__CLIENT__) {
      savedState = _jsCookie2.default.get("auth");
    }

    if (savedState) {
      try {
        var parsed = JSON.parse(savedState);
        var token = parsed.token,
            refreshToken = parsed.refreshToken;

        JSON.parse(_jsBase.Base64.decode(token.split(".")[0]));

        var _JSON$parse = JSON.parse(_jsBase.Base64.decode(token.split(".")[1])),
            email = _JSON$parse.email,
            exp = _JSON$parse.exp;

        if (!exp || exp * 1000 <= Date.now()) {
          return dispatch(refreshLogin({ email: email, token: token, refreshToken: refreshToken }));
        } else {
          return dispatch({
            type: LOAD_SUCCESS,
            result: parsed
          });
        }
      } catch (err) {
        return dispatch({
          type: LOAD_FAIL,
          err: err
        });
      }
    } else {
      return dispatch({
        type: LOAD_FAIL,
        err: new Error("No auth")
      });
    }
  };
}

function login(_ref) {
  var email = _ref.email,
      password = _ref.password;

  return function (dispatch, getState) {
    return dispatch({
      types: [LOGIN, LOGIN_SUCCESS, LOGIN_FAIL],
      meta: { email: email },
      promise: function promise(client) {
        return client.post("sso://v1/login", {
          data: { email: email, password: password, realm: "megascans" }
        }).then(function (response) {
          var token = response.token,
              refreshToken = response.refreshToken;

          var user = JSON.parse(_jsBase.Base64.decode(token.split(".")[1]));

          if (user.scope.indexOf("megascans:user") == -1) {
            throw new Error("You don't seem to be a part of the Megascans private beta (yet!)");
          }

          if (__CLIENT__) {
            var auth = (0, _stringify2.default)({ token: token, refreshToken: refreshToken });
            _jsCookie2.default.set("auth", auth);
          }

          var additionalHeaders = {
            "Content-Type": "application/x-www-form-urlencoded"
          };
          var externalCall = true;
          client.post("hubspot://uploads/form/v2/" + "5267366" + "/" + "28cbd80e-ed9d-443d-bee6-b38bf7587fa9", {
            data: _querystring2.default.stringify({
              email: email,
              hs_context: (0, _stringify2.default)({
                // "ipAddress": req.headers['x-forwarded-for'] || req.connection.remoteAddress,
                pageUrl: "/login",
                pageName: "Login"
              })
            }),
            additionalHeaders: additionalHeaders,
            externalCall: externalCall
          });

          return response;
        }).catch(function (error) {
          error._error = error.message;
          throw error;
        });
      }
    }).then(function () {
      dispatch((0, _assets.getAcquiredAssets)());
      dispatch((0, _assets.getFavorites)());
      return dispatch(userActions.load());
    });
  };
}

function registerAndLogin(_ref2) {
  var email = _ref2.email,
      password = _ref2.password,
      name = _ref2.name;

  return function (dispatch, getState) {
    return dispatch({
      types: [REGISTER, REGISTER_SUCCESS, REGISTER_FAIL],
      promise: function promise(client) {
        return client.post("sso://v1/users", { data: { email: email, password: password, name: name } });
      }
    }).then(function () {
      return dispatch(login({ email: email, password: password }));
    });
  };
}

function refreshLogin(_ref3) {
  var email = _ref3.email,
      token = _ref3.token,
      refreshToken = _ref3.refreshToken;

  return function (dispatch, getState) {
    return dispatch({
      types: [REFRESH, REFRESH_SUCCESS, REFRESH_FAIL],
      promise: function promise(client) {
        var _getState2 = getState(),
            _getState2$server = _getState2.server,
            req = _getState2$server.req,
            res = _getState2$server.res;

        var additionalHeaders = __SERVER__ ? { "User-Agent": req.get("user-agent") } : {};

        return client.post("sso://v1/login", {
          data: { email: email, token: token, refreshToken: refreshToken, realm: "megascans" },
          additionalHeaders: additionalHeaders
        }).then(function (response) {
          var token = response.token,
              refreshToken = response.refreshToken;


          var auth = (0, _stringify2.default)({ token: token, refreshToken: refreshToken });

          if (__CLIENT__) {
            _jsCookie2.default.set("auth", auth);
          } else if (__SERVER__) {
            res.cookie("auth", auth);
          }

          var additionalHeaders = {
            "Content-Type": "application/x-www-form-urlencoded"
          };
          var externalCall = true;
          client.post("hubspot://uploads/form/v2/" + "5267366" + "/" + "28cbd80e-ed9d-443d-bee6-b38bf7587fa9", {
            data: _querystring2.default.stringify({
              email: email,
              hs_context: (0, _stringify2.default)({
                // "ipAddress": req.headers['x-forwarded-for'] || req.connection.remoteAddress,
                pageUrl: "/login",
                pageName: "Login"
              })
            }),
            additionalHeaders: additionalHeaders,
            externalCall: externalCall
          });

          return response;
        }).catch(function (error) {
          if (__CLIENT__) {
            _jsCookie2.default.set("auth", "");
          } else if (__SERVER__) {
            res.cookie("auth", "");
          }

          throw error;
        });
      }
    });
  };
}

function logout() {
  var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  if (__CLIENT__) {
    localStorage.setItem("closedTrialPopup", false);
    localStorage.setItem("closedExpiredTrialPopup", false);
  }
  return function (dispatch, getState) {
    return dispatch({
      types: [LOGOUT, LOGOUT_SUCCESS, LOGOUT_FAIL],
      promise: function promise(client) {
        return client.post("sso://v1/logout").finally(function (response) {
          _jsCookie2.default.remove("auth");

          if (__CLIENT__ && force) {
            _reactRouter.browserHistory.replace("/");
          }
        });
      }
    }).then(function () {
      return dispatch((0, _payments.resetPromocode)());
    }).then(function () {
      return dispatch(resetEULA());
    }).then(function () {
      return dispatch((0, _assets.getCategoryAssetCount)(false));
    }).then(function () {
      if (window) {
        window.localStorage.setItem("quixelLogin", false);
      }
    });
  };
}

function updatePassword(newPassword, confirmPassword, oldPassword) {
  return {
    types: [UPDATE_PASSWORD, UPDATE_PASSWORD_SUCCESS, UPDATE_PASSWORD_FAIL],
    promise: function promise(client) {
      var payload = {
        oldpassword: oldPassword,
        newpassword: newPassword,
        confirmpassword: confirmPassword
      };

      return client.put("sso://v1/changepassword", {
        data: payload
      }).then(function (res) {
        return (0, _extends3.default)({}, res.data);
      });
    }
  };
}

function resetUpdatePassword() {
  return {
    type: UPDATE_INIT
  };
}

function forgotPassword(email, captchaResponse) {
  return {
    types: [FORGOT_PASSWORD, FORGOT_PASSWORD_SUCCESS, FORGOT_PASSWORD_FAIL],
    promise: function promise(client) {
      var payload = {
        captchaResponse: captchaResponse
      };

      return client.post("sso://v1/users/" + encodeURIComponent(email) + "/forgot_password", { data: payload });
    }
  };
}

function checkIfExists(email, checkFor) {
  return function (dispatch, getState) {
    if (getState().auth.checkedIfExist == email) return _bluebird2.default.resolve();

    return dispatch({
      types: [CHECK_IF_EXISTS, CHECK_IF_EXISTS_SUCCESS, CHECK_IF_EXISTS_FAIL],
      meta: { checkFor: checkFor, email: email },
      promise: function promise(client) {
        return client.post("sso://v1/login", { data: { email: email, realm: "megascans" } }).catch(function (e) {
          return e;
        });
      }
    });
  };
}

function loginWithSSOZendesk(_ref4) {
  var email = _ref4.email,
      password = _ref4.password,
      realm = _ref4.realm;

  return function (dispatch, getState) {
    return dispatch({
      types: [LOGIN_ZENDESK_SS0, LOGIN_SUCCESS_ZENDESK_SS0, LOGIN_FAIL_ZENDESK_SS0],
      promise: function promise(client) {
        return client.post("sso://v1/zendesk/login", { data: { email: email, password: password, realm: realm } }).then(function (response) {
          response.screenName = _jsonwebtoken2.default.decode(response.token).name;
          return response;
        }).catch(function (error) {
          error._error = error.message;
          throw error;
        });
      }
    });
  };
}
function updateScreenNameSSOZendesk(_ref5) {
  var token = _ref5.token,
      screenName = _ref5.screenName,
      avatarUrl = _ref5.avatarUrl;

  return function (dispatch, getState) {
    return dispatch({
      types: [LOGIN_ZENDESK_SS0, LOGIN_SUCCESS_ZENDESK_SS0, LOGIN_FAIL_ZENDESK_SS0],
      promise: function promise(client) {
        return client.post("sso://v1/user/info", {
          data: { token: token, screenName: screenName, avatarUrl: avatarUrl }
        }).then(function (response) {
          response.screenName = _jsonwebtoken2.default.decode(response.token).name;
          return response;
        }).catch(function (error) {
          error._error = error.message;
          throw error;
        });
      }
    });
  };
}
function uploadAvatarZendesk(base64String) {
  return function (dispatch, getState) {
    return dispatch({
      types: [UPLOAD_ZENDESK_AVATAR, UPLOAD_SUCCESS_ZENDESK_AVATAR, UPLOAD_FAIL_ZENDESK_AVATAR],
      promise: function promise(client) {
        return client.post("lamda://upload", { data: { base64String: base64String } }).then(function (response) {
          return response;
        }).catch(function (error) {
          error._error = error.message;
          throw error;
        });
      }
    });
  };
}

function setZendeskScreenName(screenName) {
  return {
    type: SET_SCREEN_NAME_ZENDESK_SS0,
    meta: { screenName: screenName }
  };
}

function setZendeskAvatar(imgSrc) {
  return {
    type: SET_UPLOAD_ZENDESK_AVATAR,
    meta: { imgSrc: imgSrc }
  };
}

// Epic
function epicLogin(code) {
  var realm = "megascans";

  return function (dispatch) {
    return dispatch({
      types: [EPIC_LOGIN, EPIC_LOGIN_SUCCESS, EPIC_LOGIN_FAIL],
      promise: function promise(client) {
        return client.post("sso://v1/login/epic", {
          data: {
            code: code,
            realm: realm
          }
        }).then(function (res) {
          if (res.isUnlinkedAccount !== true) {
            var token = res.token,
                refreshToken = res.refreshToken;

            if (__CLIENT__) {
              var auth = (0, _stringify2.default)({ token: token, refreshToken: refreshToken });
              _jsCookie2.default.set("auth", auth);
            }

            dispatch({ type: LOGIN_SUCCESS, result: res });
            dispatch((0, _assets.getAcquiredAssets)());
            dispatch((0, _assets.getFavorites)()).then(function () {
              if (token) {
                var _email = _jsonwebtoken2.default.decode(token).email;

                var additionalHeaders = {
                  "Content-Type": "application/x-www-form-urlencoded"
                };
                var externalCall = true;
                client.post("hubspot://uploads/form/v2/" + "5267366" + "/" + "28cbd80e-ed9d-443d-bee6-b38bf7587fa9", {
                  data: _querystring2.default.stringify({
                    email: _email,
                    hs_context: (0, _stringify2.default)({
                      // "ipAddress": req.headers['x-forwarded-for'] || req.connection.remoteAddress,
                      pageUrl: "/login",
                      pageName: "Login"
                    })
                  }),
                  additionalHeaders: additionalHeaders,
                  externalCall: externalCall
                });
              }
            });
            return dispatch(userActions.load());
          }

          return res;
        }).catch(function (err) {
          err._error = err.message;
          throw err;
        });
      }
    });
  };
}

function epicLinkAccounts(_ref6) {
  var quixelEmail = _ref6.quixelEmail,
      password = _ref6.password;

  var realm = "megascans";

  return function (dispatch, getState) {
    var state = getState();
    var _state$auth = state.auth,
        epicLogin = _state$auth.epicLogin,
        user = _state$auth.user;
    var epicLinkEmail = epicLogin.email,
        epicToken = epicLogin.epicToken;


    var email = void 0;
    var loginFn = void 0;
    if (user && user.email) {
      email = user.email;
      loginFn = verifyLogin;
    } else if (!user && quixelEmail) {
      email = quixelEmail;
      loginFn = verifyLogin;
    } else {
      email = epicLinkEmail;
      loginFn = login;
    }

    return dispatch(loginFn({ email: email, password: password })).then(function () {
      return dispatch({
        types: [EPIC_LINK_ACCOUNT, EPIC_LINK_ACCOUNT_SUCCESS, EPIC_LINK_ACCOUNT_FAIL],
        promise: function promise(client) {
          return client.post("sso://v1/accounts/link/epic", {
            data: {
              epicToken: epicToken,
              realm: realm
            }
          }).then(function (res) {
            var token = res.token,
                refreshToken = res.refreshToken;


            if (__CLIENT__) {
              var auth = (0, _stringify2.default)({ token: token, refreshToken: refreshToken });
              _jsCookie2.default.set("auth", auth);
            }

            dispatch({ type: LOGIN_SUCCESS, result: res });

            var additionalHeaders = {
              "Content-Type": "application/x-www-form-urlencoded"
            };
            var externalCall = true;
            client.post("hubspot://uploads/form/v2/" + "5267366" + "/" + "28cbd80e-ed9d-443d-bee6-b38bf7587fa9", {
              data: _querystring2.default.stringify({
                email: email,
                hs_context: (0, _stringify2.default)({
                  // "ipAddress": req.headers['x-forwarded-for'] || req.connection.remoteAddress,
                  pageUrl: "/login",
                  pageName: "Login"
                })
              }),
              additionalHeaders: additionalHeaders,
              externalCall: externalCall
            });

            return res;
          }).catch(function (err) {
            throw err;
          });
        }
      }).then(function () {
        dispatch((0, _assets.getAcquiredAssets)());
        dispatch((0, _assets.getFavorites)());

        return dispatch(userActions.load());
      }).catch(function (err) {
        if (err.code === "AccountAlreadyLinked") {
          return; // absolve error chain and move to then chain
        } else {
          err._error = "Something went wrong while linking your accounts. Please try again in a short while.";
        }

        throw err;
      });
    });
  };
}

function verifyLogin(_ref7) {
  var email = _ref7.email,
      password = _ref7.password;

  return function (dispatch) {
    return dispatch({
      types: [VERIFY_LOGIN, VERIFY_LOGIN_SUCCESS, VERIFY_LOGIN_FAIL],
      meta: { email: email },
      promise: function promise(client) {
        return client.post("sso://v1/login", {
          data: { email: email, password: password, realm: "megascans" }
        }).then(function (res) {
          var token = res.token,
              refreshToken = res.refreshToken;


          if (__CLIENT__) {
            var auth = (0, _stringify2.default)({ token: token, refreshToken: refreshToken });
            _jsCookie2.default.set("auth", auth);
          }

          dispatch({ type: LOGIN_SUCCESS, result: res });
          return res;
        }).then(function () {
          dispatch((0, _assets.getAcquiredAssets)());
          dispatch((0, _assets.getFavorites)());

          return dispatch(userActions.load());
        }).catch(function (err) {
          err._error = err.message;
          throw err;
        });
      }
    });
  };
}

function validateEula() {
  return function (dispatch, getState) {
    var state = getState();
    var subscription = state.user.subscription,
        _state$auth2 = state.auth,
        loaded = _state$auth2.eula.loaded,
        loggedIn = _state$auth2.loggedIn;


    if (loaded || !loggedIn) {
      return;
    }

    if (subscription) {
      var planId = subscription.planId,
          doesGetCharged = subscription.doesGetCharged,
          isActive = subscription.isActive;

      var isStudioOrCustomPlan = planId !== "unreal-unlimited" && doesGetCharged === false && isActive;

      if (isStudioOrCustomPlan) return new _promise2.default(function (resolve) {
        return resolve(true);
      });
    }

    return dispatch({
      types: [VALIDATE_EULA, VALIDATE_EULA_SUCCESS, VALIDATE_EULA_FAIL],
      promise: function promise(client) {
        return client.get("sso://v1/epic_eula/content");
      }
    });
  };
}
function acceptEULA() {
  return function (dispatch, getState) {
    var state = getState();
    var nextVersion = state.auth.eula && state.auth.eula.version;
    return dispatch({
      types: [ACCEPT_EULA, ACCEPT_EULA_SUCCESS, ACCEPT_EULA_FAIL],
      promise: function promise(client) {
        return client.post("sso://v1/epic_eula/content/accept", {
          data: {
            isAccepted: true,
            version: nextVersion,
            locale: "en"
          }
        });
      }
    }).then(function (res) {
      var token = res.token,
          refreshToken = res.refreshToken;


      if (__CLIENT__) {
        var auth = (0, _stringify2.default)({ token: token, refreshToken: refreshToken });
        _jsCookie2.default.set("auth", auth);
      }

      dispatch({ type: LOGIN_SUCCESS, result: res });
    });
  };
}

function resetEULA() {
  return function (dispatch) {
    return dispatch({
      type: RESET_EULA
    });
  };
}

function loginError(err) {
  return function (dispatch) {
    return dispatch({
      type: LOGIN_FAIL,
      error: err
    });
  };
}

function resetLoginError() {
  return function (dispatch) {
    return dispatch({
      type: RESET_LOGIN_ERROR
    });
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/auth.js
// module id = 37
// module chunks = 0